import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-32" }
const _hoisted_2 = { class: "me-8" }
const _hoisted_3 = { class: "text-primary" }
const _hoisted_4 = ["aria-label", "title"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-copy-light text-primary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "send-link" }
const _hoisted_8 = { class: "send-link-buttons" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-phone me-16",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-message me-16",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_modal_body = _resolveComponent("modal-body")!
  const _component_modal_footer = _resolveComponent("modal-footer")!
  const _component_v_modal = _resolveComponent("v-modal")!

  return (_openBlock(), _createBlock(_component_v_modal, {
    size: "xl",
    "class-name": "modal-fullscreen-lg-down"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_modal_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_modal_title, { as: "h4" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Compartir enlace de acceso a la videollamada')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_modal_body, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, [
              _createTextVNode(_toDisplayString(_ctx.$t('Este es el enlace de invitación a la videollamada:')) + " ", 1),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.currentRoom.url), 1)
            ]),
            _createElementVNode("a", {
              "aria-label": _ctx.$t('Copiar'),
              title: _ctx.$t('Copiar'),
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.copyLink && _ctx.copyLink(...args)), ["prevent"]))
            }, _hoisted_6, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('También puedes enviar el enlace al correo electrónico o a través de un SMS del paciente:')), 1),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_v_button, {
                variant: "primary",
                class: "btn-icon me-24",
                "aria-label": _ctx.$t('Enviar correo electrónico'),
                onClick: _ctx.sendUrlToPatientViaMail
              }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('Enviar correo electrónico')), 1)
                ]),
                _: 1
              }, 8, ["aria-label", "onClick"]),
              _createVNode(_component_v_button, {
                variant: "primary",
                class: "btn-icon me-24",
                "aria-label": _ctx.$t('Enviar SMS'),
                onClick: _ctx.sendUrlToPatientViaSMS
              }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('Enviar SMS')), 1)
                ]),
                _: 1
              }, 8, ["aria-label", "onClick"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_modal_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_button, {
            variant: "link-secondary",
            class: "me-24",
            "aria-label": _ctx.$t('Cancelar'),
            "data-bs-dismiss": "modal"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Cancelar')), 1)
            ]),
            _: 1
          }, 8, ["aria-label"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}